import { defineComponent as _defineComponent } from 'vue'
import LoyaltyDropDataTable from "@/components/loyaltyDrop/LoyaltyDropDataTable.vue";
import {onMounted, onUnmounted} from "vue";
import dataService from "@/services/data.service";
import StakeManagementIcon from "@/components/commons/StakeManagementIcon.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'LoyaltyDropView',
  setup(__props, { expose: __expose }) {
  __expose();


onMounted(() => {
  dataService.onLoyaltyDropSelected();
});

onUnmounted(() => {
  dataService.onLoyaltyDropUnselected();
});

async function withdraw(){
  await dataService.onVestingPoolWithdrawAllAvailable();
}


const __returned__ = { withdraw, LoyaltyDropDataTable, StakeManagementIcon }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})